import script from "./CardAlojamientoRooming.vue?vue&type=script&setup=true&lang=js"
export * from "./CardAlojamientoRooming.vue?vue&type=script&setup=true&lang=js"

import "./CardAlojamientoRooming.vue?vue&type=style&index=0&id=b54401f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b54401f2"]])

export default __exports__